module.exports = __webpack_public_path__ + "static/media/fairfunderLogo.d3ca1106.png";